import { Injectable } from '@angular/core';
import { HttpApiService } from '../base/http-api.service';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../../entities/api-response.model';
import { CoccidiostatsModel } from '../../entities/coccidiostats.model';

@Injectable({
  providedIn: 'root'
})
export class CoccidiostatsService {

    constructor(
        public httpApiService: HttpApiService,
    ) {

    }

    public get(uid): Observable<ApiResponseModel>
    {
        return this.httpApiService.httpGet('coccidiostats/view', {uid});
    }

    public getList(): Observable<ApiResponseModel>
    {
        return this.httpApiService.httpGet('coccidiostats/view-list');
    }

    public set(coccidiostat: CoccidiostatsModel): Observable<ApiResponseModel>
    {
        return this.httpApiService.httpPost('coccidiostats/store', coccidiostat);
    }

    public delete(uid): Observable<ApiResponseModel> {
        return this.httpApiService.httpDelete('coccidiostats/destroy', { uid });
    }
}
